<script>
export default {
  props: ["clr"]
};
</script>
<template>
  <svg
    id="Qr_code.1"
    data-name="Qr code.1"
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
  >
    <g id="Group_1366" data-name="Group 1366" transform="translate(2.5 2.5)">
      <path
        id="Path_8617"
        data-name="Path 8617"
        d="M7.167,8H3.833A.834.834,0,0,1,3,7.167V3.833A.834.834,0,0,1,3.833,3H7.167A.834.834,0,0,1,8,3.833V7.167A.834.834,0,0,1,7.167,8Zm0,10H3.833A.834.834,0,0,1,3,17.167V13.833A.834.834,0,0,1,3.833,13H7.167A.834.834,0,0,1,8,13.833v3.333A.834.834,0,0,1,7.167,18Zm10-10H13.833A.834.834,0,0,1,13,7.167V3.833A.834.834,0,0,1,13.833,3h3.333A.834.834,0,0,1,18,3.833V7.167A.834.834,0,0,1,17.167,8Z"
        transform="translate(-3 -3)"
        fill="none"
        :stroke="clr ? clr : `#500fe9`"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        fill-rule="evenodd"
      />
    </g>
    <path
      id="Path_8618"
      data-name="Path 8618"
      d="M7,12H8.667"
      transform="translate(-1.167 -2)"
      fill="none"
      :stroke="clr ? clr : `#500fe9`"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
    <g id="Group_1367" data-name="Group 1367" transform="translate(2.5 2.5)">
      <path
        id="Path_8619"
        data-name="Path 8619"
        d="M10.5,4.667V3m3.333,7.5h-2.5a.834.834,0,0,1-.833-.833V8M3.833,10.5H3m10,5H11.333a.834.834,0,0,0-.833.833V18m0-5h5M18,13v4.167a.834.834,0,0,1-.833.833H13M5.5,5.492a0,0,0,1,0,0,.008,0,0,0,0,0,0-.008,0,0,0,0,0,0,0m10,0a0,0,0,1,0,0,.008,0,0,0,0,0,0-.008,0,0,0,0,0,0,0m.833,5a0,0,0,1,0,0,.008,0,0,0,0,0,0-.008,0,0,0,0,0,0,0"
        transform="translate(-3 -3)"
        fill="none"
        :stroke="clr ? clr : `#500fe9`"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
      <path
        id="Path_8620"
        data-name="Path 8620"
        d="M16,18A0,0,0,0,0,16,18,0,0,0,0,0,16,18a0,0,0,0,0,0,0M6,18A0,0,0,1,0,6,18,0,0,0,0,0,6,18a0,0,0,0,0,0,0"
        transform="translate(-3.5 -5.499)"
        fill="none"
        :stroke="clr ? clr : `#500fe9`"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
    </g>
    <path id="Path_8621" data-name="Path 8621" d="M0,0H20V20H0Z" fill="none" />
  </svg>
</template>
